var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductSeatLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.668,
    width: 17.3333,
    height: 16,
    rx: 2,
    fill: "#C1F700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.668 8.00174C18.668 7.38809 18.7259 6.89062 18.7974 6.89062H29.6496C29.7211 6.89062 29.7791 7.38809 29.7791 8.00174C29.7791 8.61539 29.7211 9.11285 29.6496 9.11285H18.7974C18.7259 9.11285 18.668 8.61539 18.668 8.00174Z",
    fill: "#1C1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3487 2.11436C25.6471 1.81605 26.1307 1.81605 26.429 2.11436L31.7763 7.46159C32.0746 7.7599 32.0746 8.24357 31.7763 8.54189L26.429 13.8891C26.1307 14.1874 25.6471 14.1874 25.3487 13.8891C25.0504 13.5908 25.0504 13.1071 25.3487 12.8088L30.1558 8.00174L25.3487 3.19466C25.0504 2.89635 25.0504 2.41268 25.3487 2.11436Z",
    fill: "#1C1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.0013C0 7.26492 0.10434 6.66797 0.233051 6.66797H19.7669C19.8957 6.66797 20 7.26492 20 8.0013C20 8.73768 19.8957 9.33464 19.7669 9.33464H0.233051C0.10434 9.33464 0 8.73768 0 8.0013Z",
    fill: "#C1F700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSeatLeftArrow);
export default __webpack_public_path__ + "static/media/product-seat-left-arrow.83062c8b9ad2b648089187409fa09835.svg";
export { ForwardRef as ReactComponent };